import { Spacer, Text } from '@oy/ui';
import { Colors, FontStyleEnums } from '@oy/uicore';
import classNames from 'classnames';
import React, {
  DetailedHTMLProps,
  InputHTMLAttributes,
  ReactNode,
} from 'react';
import styles from './Toggle.module.css';

type ToggleProps = {
  title?: string;
  uncheckedTitle?: string;
  titleColor?: Colors;
  uncheckedTitleColor?: Colors;
  description?: string;
  titleStyle?: FontStyleEnums;
  uncheckedTitleStyle?: FontStyleEnums;
  descriptionStyle?: FontStyleEnums;
  customDescription?: ReactNode;
} & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

const Toggle = ({
  checked = false,
  title,
  uncheckedTitle,
  titleColor,
  uncheckedTitleColor,
  description,
  titleStyle = FontStyleEnums.BodyMdRegular,
  uncheckedTitleStyle = FontStyleEnums.BodyMdRegular,
  descriptionStyle = FontStyleEnums.BodyMdRegular,
  customDescription,
  ...props
}: ToggleProps) => {
  return (
    <div
      className={classNames(styles.container, {
        [styles.alignCenter]: !description && !customDescription,
      })}
    >
      {uncheckedTitle && (
        <Spacer right={Spacer.Size.S}>
          <Text textStyle={uncheckedTitleStyle} color={uncheckedTitleColor}>
            {uncheckedTitle}
          </Text>
        </Spacer>
      )}
      <label className={styles.toggleContainer}>
        <input
          type="checkbox"
          className={styles.hiddenInput}
          id="hidden-input"
          name="hidden-input"
          checked={checked}
          {...props}
        />
        <span className={styles.thumbContainer}>
          <span className={styles.thumb}></span>
        </span>
        <span className={styles.track}></span>
      </label>
      {title && (
        <Spacer left={Spacer.Size.S}>
          <Text textStyle={titleStyle} color={titleColor}>
            {title}
          </Text>
          {customDescription ||
            (description && (
              <Spacer top={Spacer.Size.XXXS}>
                <Text textStyle={descriptionStyle}>{description}</Text>
              </Spacer>
            ))}
        </Spacer>
      )}
    </div>
  );
};

export default Toggle;
